export class KeyboardShortcuts
{
	constructor(store)
    {
        this.store = store
	}

	watch()
	{
		addEventListener("keydown", (v) => {
			if (v.altKey) {
				if (v.code == "KeyG") {
					window.location = store.slugs["mainpage"]
				}
				if (v.code == "KeyM") {
					window.location = "#menu"
				}
				if (v.code == "KeyT") {
					window.location = "#tresc"
				}
				if (v.code == "KeyW") {
					this.store.service.Modal.target = "search"
					this.store.service.Modal.show()
				}
				if (v.code == "KeyP") {
					window.location = "/"+store.slugs["sitemap"]
				}
				if (v.code == "KeyN") {
					this.store.service.Accessibility.check()
				}
				if (v.code == "KeyS") {
					window.location = (store.config.mode.contrast.enable) ? "/"+store.slugs["contrast-deactivate"] : "/"+store.slugs["contrast-activate"]
				}
				if (v.code == "KeyA") {
					window.location = (store.config.mode.text.enable) ? "/"+store.slugs["text-deactivate"] : "/"+store.slugs["text-activate"]
				}
				if (v.code == "KeyL") {
					let e = document.querySelector('[data-s~="Lector:play"][data-uuid~="f5e14738-95f4-48e0-ac8f-b3cb40d9aefa"]')
					this.store.service.Lector.play(e)
				}
				if (v.code == "KeyZ") {
					this.store.service.Install.install()
				}
			}
		})
	}
}
